import { EntityKind, buildBusinessErrorFromError, } from '@mgdis/eu-domain';
class ContributionsVEFRestAdapter {
    tenantId;
    restHttpAdapter;
    /**
     * API of contributions.
     *
     */
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
    }
    /**
     * Call API: Get number of contribution vef.
     *
     */
    async countContributionsVEF(filters) {
        try {
            const res = await this.restHttpAdapter.post(`/referentiel-financement-bourse/api/tenants/${this.tenantId}/private/contributions-vef/count`, { aideSearch: filters });
            return { response: res.data };
        }
        catch (error) {
            return {
                error: buildBusinessErrorFromError(error),
            };
        }
    }
    async check(reference, data) {
        try {
            await this.restHttpAdapter.post(`/referentiel-financement-bourse/api/tenants/${this.tenantId}/private/contributions-vef/${reference}/check`, data);
            return { response: true };
        }
        catch (error) {
            return {
                error: buildBusinessErrorFromError(error),
            };
        }
    }
    async validate(data) {
        try {
            const result = await this.restHttpAdapter.post(`/referentiel-financement-bourse/api/tenants/${this.tenantId}/private/contributions-vef/validate`, data);
            const isSuccessful = result.data?.every(({ status }) => status == 'SUCCESS');
            if (!isSuccessful)
                throw new Error("At least one contribution-vef wasn't validated");
            return { response: isSuccessful };
        }
        catch (error) {
            return {
                error: buildBusinessErrorFromError(error),
            };
        }
    }
    /**
     * Call API: get contributions VEF.
     */
    async searchContributionsVEF(pagination, aggregations, filters) {
        try {
            const res = await this.restHttpAdapter.post(`/referentiel-financement-bourse/api/tenants/${this.tenantId}/private/contributions-vef/search`, {
                from: pagination.from,
                size: pagination.size,
                aggregations,
                aideSearch: filters,
                type: 'AIDES_APPRENANTS',
            });
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
}
export { ContributionsVEFRestAdapter };
//# sourceMappingURL=contributions-vef-rest.adapter.js.map